<template>
  <div class="toggle" :class="{ 'toggle--true': value }" @click="onClick()">
    <div class="emoji-container">
      <p class="emoji">{{ emoji | emoji }}</p>
    </div>
    <p class="emoji-text">
      {{ label | translate }}
    </p>
  </div></template
>

<script>
export default {
  name: "toggle",
  props: {
    emoji: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: Boolean
    }
  },
  methods: {
    onClick() {
      this.$emit("input", !this.value);
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.toggle {
  cursor: pointer;
  width: 142px;
  height: 34px;
  background-color: $gyra-grey-lightest;
  border-radius: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.toggle--true {
  background-color: $gyra-salmon;
}

.emoji-container {
  margin: 2px 5px 2px 2px;
  background-color: white;
  border-radius: 100px;
  height: 29px;
  width: 29px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.emoji {
  margin-bottom: 0;
}

.emoji-text {
  font-weight: bold;
  font-size: 11px;
  margin-bottom: 0;
}
</style>
